<template>
  <div>
    <p class="page-info" v-if="pageInfo">{{ pageInfo }}</p>
    <v-publisher-pages
      v-for="(page, index) in pages"
      :key='index'
      :start="page.start"
      :end="page.end"
      :showAddBtn="index === 0"
      :showRemoveBtn="index !== 0"
      :textFieldCols="textFieldCols"
      @update-start="(val) => updatePublisherPage({ index: index, pages: { start: val } })"
      @update-end="(val) => updatePublisherPage({ index: index, pages: { end: val } })"
      @update-error="(bool) => updatePublisherPage({ index: index, pages: { error: bool } })"
      @add-range="addPublisherPage"
      @remove-range="removePublisherPage({ index: index})"
    />
  </div>
</template>

<script>
import VPublisherPages from '@/components/molecules/PublisherPages'
import teacher from '../../mixins/teacher';
import { mapMutations } from 'vuex'

export default {
  mixins: [teacher],

  components: {
    VPublisherPages,
  },

  props: {
    textFieldCols: {
      type: Object,
      default: () => ({ lg: 3, md: 3, sm: 4 }),
    }
  },

  data: () => ({
    chapters: []
  }),

  computed: {
    pages() {
      return this.currentSubjectCondition.publisherPages
    },

    currentSubject() {
      return this.$store.state.master.allSubjects.find(subject => subject.code === this.currentSubjectCondition.code)
    },

    selectedPublisher() {
      return this.currentSubjectCondition.selectedPublisher
    },

    pageInfo() {
      if (!this.selectedPublisher) return null

      if (this.selectedPublisher.endPage) {
        return `※${this.currentSubject.name}のページ範囲はp${this.selectedPublisher.endPage}までです。`
      }

      if (this.selectedPublisher.startPage) {
        return `※${this.currentSubject.name}のページ範囲はp${this.selectedPublisher.startPage}～です。`
      }

      return null
    },
  },

  methods: {
    ...mapMutations([
      'addPublisherPage',
      'removePublisherPage',
      'updatePublisherPage'
    ]),
  },
}
</script>

<style lang="stylus" scoped>
.alert-message
  color #ff0606
  font-weight bold
  font-size 14px
  margin-top 5px

.page-info
  font-size 14px
</style>
